import { REDUCER_NAME_FEEDBACK_FORMS } from 'utils/enums/reducersNames'
import { feedbackFormsSchema } from 'store/entities/feedbackForms/FeedbackFormsSchema'
import { selectorsCreators } from 'store/common'

export const pristineData = {
  id: null,
  uuid: null,
  type: null,
  status: null,
  attributes: {},
}

const creatorSettings = {
  schema: feedbackFormsSchema,
  entityKey: REDUCER_NAME_FEEDBACK_FORMS,
}

export const getFormById = selectorsCreators.makeGetEntityById({
  ...creatorSettings,
  pristineData,
})
